import { useSelector } from "react-redux";
import TypeSelector from "../../ui/type-selector/TypeSelector";
import { useEffect } from "react";
import { baseTitle } from "../../../constants/messages";
import { formTypes } from "../../../constants/keys";

function PersonalClaim({ onTypeSelect, selected }) {
  const visible = useSelector((state) => state.app.visibleSelectors);

  useEffect(() => {
    document.title = baseTitle + " - Report Personal Claim";
  }, []);

  return (
    <div>
      <div className="selectorContainer">
        {(visible.auto || selected.auto) && (
          <TypeSelector
            id="auto"
            name={formTypes.Auto}
            onSelectType={onTypeSelect}
            selected={selected.auto}
          />
        )}
        {(visible.auto || selected.glass) && (
          <TypeSelector
            id="glass"
            name={formTypes.AutoGlass}
            onSelectType={onTypeSelect}
            selected={selected.glass}
          />
        )}
        {(visible.home || selected.home) && (
          <TypeSelector
            id="home"
            name={formTypes.Home}
            onSelectType={onTypeSelect}
            selected={selected.home}
          />
        )}
      </div>
    </div>
  );
}

export default PersonalClaim;
